import React from 'react';

// Components
import TeaserText from './teaser-text/teaser-text';
import Movies from './movies/movies';
import SlideShow from './slide-show/slide-show';
import References from './references/references';
import Counter from './counter/counter';
import People from './people/people';
import Press from './press/press';
import Awards from './awards/awards';

// Content
import MovieContent from '../../public/content/sections/movies.json';
import AwardsContent from '../../public/content/sections/awards.json';
import TeaserTextContent from '../../public/content/sections/teaser--creative-pictures-in-motion.json';
import SliderContent from '../../public/content/sections/impressions.json';
import ReferencesImageContent from '../../public/content/sections/references.json';
import CounterContent from '../../public/content/sections/counter.json';
import PressContent from '../../public/content/sections/press.json';
import PeopleContent from '../../public/content/sections/people.json';
import OtionalContent from '../../public/content/sections/optional-section.json';

import css from './../../public/css/style.css';

class Sections extends React.Component {
  render() {
    return (
      <main className="main">
        <TeaserText content={TeaserTextContent} />
        <Movies content={MovieContent} />
        <References content={ReferencesImageContent} />
        <Awards content={AwardsContent} />
        <People content={PeopleContent} />
        {OtionalContent.visible &&
        <TeaserText content={OtionalContent} />
        }
        <SlideShow content={SliderContent} />
        <Counter content={CounterContent} />
        <Press content={PressContent} />
      </main>
    );
  }
}

export default Sections;


// WEBPACK FOOTER //
// ./src/sections/sections.jsx